module.exports = __webpack_public_path__ + "img/calcaneare_sx.3cdf9acc.png";